export const collectReportFilters = (
  report: Record<string, unknown>,
  reportDecoded: Record<string, unknown> | null | undefined,
) => {
  const filterTables: unknown[] = [];
  const filterValues: unknown[] = [];
  const filterOptions: unknown[] = [];

  const push = (source: Record<string, unknown>, callback: () => void = () => undefined) => {
    if (source.filterTables) {
      filterTables.push(source.filterTables);
    }
    if (source.filterValues) {
      filterValues.push(source.filterValues);
    }
    if (source.filterOptions) {
      filterOptions.push(source.filterOptions);
    }
    callback();
  };

  push(report, () => {
    if (reportDecoded) {
      push(reportDecoded);
    }
  });

  ((report.drill || []) as object[]).forEach((item) => {
    push(item as Record<string, unknown>);
  });

  if (filterTables.length && filterValues.length && filterOptions.length) {
    return {
      filterTables,
      filterValues,
      filterOptions: report.filterOptions,
    };
  }

  return {};
};
